//
// Copyright 2026 DXOS.org
//
// streamx@2.23.0 added events-universal as a dep; bundle npm events polyfill.

export * from 'hypercore';
export { default } from 'hypercore';
